import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/administration/tariffs',
    name: RouteName.AdministrationTariffs,
    component: () => import('@/pages/Tariffs/TariffList.vue'),
    meta: {
      permissions: [CRMPermission.ViewAdministrationTariffs],
      breadcrumb: {
        label: 'Тарифы',
        parent: RouteName.Administration,
      },
    },
  },
  {
    path: '/administration/tariffs/create',
    name: RouteName.AdministrationTariffCreate,
    component: () => import('@/pages/Tariffs/TariffForm.vue'),
    meta: {
      permissions: [CRMPermission.ViewAdministrationTariffs],
      breadcrumb: {
        label: 'Новый тариф',
        parent: RouteName.AdministrationTariffs,
      },
    },
  },
  {
    path: '/administration/tariffs/:id',
    name: RouteName.AdministrationTariffEdit,
    component: () => import('@/pages/Tariffs/TariffForm.vue'),
    props: { isEdit: false },
    meta: {
      permissions: [CRMPermission.ViewAdministrationTariffs],
      breadcrumb: {
        label: 'Редактирование тарифа',
        parent: RouteName.AdministrationTariffs,
      },
    },
  },
]
